import { render, staticRenderFns } from "./cdqczx.vue?vue&type=template&id=2c709e6a&scoped=true&"
import script from "./cdqczx.vue?vue&type=script&lang=js&"
export * from "./cdqczx.vue?vue&type=script&lang=js&"
import style0 from "./cdqczx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdqczx.vue?vue&type=style&index=1&id=2c709e6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c709e6a",
  null
  
)

export default component.exports